export const PRODUCTLIST = 'PRODUCTLIST';
export const GOODSLIST = 'GOODSLIST';           // 商品列表
export const CURRENTORDERINFO = 'CURRENTORDERINFO'; // 当前订单信息
export const PRODUCTINFO = 'PRODUCTINFO';
export const PRODUCTSETTING = 'PRODUCTSETTING';
export const ACCOUNTINFO = 'ACCOUNTINFO';
export const LOGINVISIBLE = 'LOGINVISIBLE';
export const SHOWQUESTION = 'SHOWQUESTION';     // 展示问题页面
export const SHOWORDERINFO = 'SHOWORDERINFO';   // 展示订单信息页面
export const SHOWERRTIP = 'SHOWERRTIP';         // 是否显示错误提示
export const ERRTIPTEXT = 'ERRTIPTEXT';         // 错误提示内容
export const GIFTSLIST = 'GIFTSLIST'; // 免费礼包

const Constant = ({
    "PRODUCTLIST":PRODUCTLIST,
    "PRODUCTINFO":PRODUCTINFO,
    "GOODSLIST":GOODSLIST,
    "CURRENTORDERINFO":CURRENTORDERINFO,
    "SHOWERRTIP":SHOWERRTIP,
    "ERRTIPTEXT":ERRTIPTEXT,
    "GIFTSLIST":GIFTSLIST
})
export default Constant;